module.exports = __webpack_public_path__ + "img/real-identity.e4299f3.png";